import { apiClient } from "./apiClient";

const endpoint = "analytics";

const getTradeSummary = (startDate: string, endDate: string) => {
  const params = `?StartDate=${startDate}&EndDate=${endDate}`;
  return apiClient(`${endpoint}/tradeSummary`).fetchWithParams(params);
};

const getSettlement = (ticker: string, observationDate: string, startMarkDate: string, endMarkDate: string) => {
  const params = `?Ticker=${ticker}&ObservationDate=${observationDate}&StartMarkDate=${startMarkDate}&EndMarkDate=${endMarkDate}`;
  return apiClient(`${endpoint}/settlement`).fetchWithParams(params);
};

const getSettlementContractDateBoundaries = (ticker: string) => {
  const params = `?Ticker=${ticker}`;
  return apiClient(`${endpoint}/settlementContractDateBoundaries`).fetchWithParams(params);
};

const getSettlementByPromptOffset = (
  ticker: string,
  promptOffset: number,
  startMarkDate: string,
  endMarkDate: string,
) => {
  const params = `?Ticker=${ticker}&PromptOffset=${promptOffset}&StartMarkDate=${startMarkDate}&EndMarkDate=${endMarkDate}`;
  return apiClient(`${endpoint}/settlementByPromptOffset`).fetchWithParams(params);
};

const getSettlementSpread = (
  ticker: string,
  promptOffsetNear: number,
  promptOffsetFar: number,
  startMarkDate: string,
  endMarkDate: string,
) => {
  const params = `?Ticker=${ticker}&PromptOffsetNear=${promptOffsetNear}&PromptOffsetFar=${promptOffsetFar}&StartMarkDate=${startMarkDate}&EndMarkDate=${endMarkDate}`;
  return apiClient(`${endpoint}/settlementSpread`).fetchWithParams(params);
};

export default {
  getTradeSummary,
  getSettlement,
  getSettlementContractDateBoundaries,
  getSettlementByPromptOffset,
  getSettlementSpread,
};
